export const progressStatus = {
  COMPLETED: 'COMPLETED',
  NOT_EXECUTED: 'NOT_EXECUTED',
  UNSELECTED: 'UNSELECTED',
  CREATED: 'CREATED', // not a true status, only for query
};

export default progressStatus;
